<template>
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_9558_42573)">
      <path
        d="M14.2222 5.22223C14.4285 5.42851 14.5444 5.70828 14.5444 6C14.5444 6.29172 14.4285 6.57149 14.2222 6.77777L12.9467 8.05331C12.865 8.13484 12.7598 8.18862 12.6459 8.20704C12.532 8.22547 12.4152 8.2076 12.312 8.15598L9.98222 6.99127C9.8639 6.93199 9.77093 6.83203 9.72036 6.70974C9.66978 6.58745 9.665 6.45103 9.70689 6.3255L10.1452 5.00834C8.76273 4.48637 7.23741 4.48637 5.85498 5.00834L6.29325 6.3255C6.33514 6.45103 6.33036 6.58745 6.27978 6.70974C6.22921 6.83203 6.13624 6.93199 6.01792 6.99127L3.68811 8.15598C3.58484 8.20764 3.46793 8.22549 3.35395 8.207C3.23996 8.1885 3.1347 8.1346 3.05306 8.05292L1.77791 6.77777C1.57163 6.57149 1.45575 6.29172 1.45575 6C1.45575 5.70828 1.57163 5.42851 1.77791 5.22223L2.16679 4.83334C5.38832 1.61182 10.6118 1.61182 13.8333 4.83334L14.2222 5.22223Z"
        stroke="#5555B6"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M3 8L2.38813 11.6712C2.18496 12.8903 3.12504 14 4.36092 14H11.6391C12.875 14 13.815 12.8903 13.6119 11.6712L13 8"
        stroke="#5555B6"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <circle cx="8" cy="10" r="1.5" stroke="#5555B6" />
    </g>
    <defs>
      <clipPath id="clip0_9558_42573">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
